import React from 'react';
import '../../styles/sections.css';
import '../../styles/requirements.css';

const Requirements = () => {
  return (
          <section className="requirements-section" style={{ marginTop: '6rem' }}>
        <div className="section-header">
          <h2>REQUIREMENTS</h2>
          <div className="underline"></div>
        </div>
        <div className="requirements-content">
        <ul>
          <li>
            <strong>Hardware Requirements:</strong> iOS device running iOS 13.0 or later, or a Mac with Xcode for development and testing.
          </li>
          <li>
            <strong>Software Requirements:</strong> React Native with Expo framework for the frontend, Go (Golang) for the backend API, and PostgreSQL for database management. Frontend testing is conducted through Apple TestFlight for iOS beta distribution.
          </li>
          <li>
            <strong>Development Environment:</strong> Node.js and npm/yarn for React Native development, Go compiler for backend services, and PostgreSQL server for database operations.
          </li>
          <li>
            <strong>API Integration:</strong> RESTful API architecture connecting the React Native frontend with the Go backend, deployed in production using AWS Lambda and API Gateway for serverless scalability and efficient request handling.
          </li>
          <li>
            <strong>Database Schema:</strong> PostgreSQL database hosted on Neon platform in production, designed with proper relationships, indexes, and constraints to support user profiles, posts, interactions, and social connections.
          </li>
          <li>
            <strong>Image Processing Pipeline:</strong> User-uploaded images are first processed through AWS Rekognition for automated content moderation and screening. Upon successful verification, images are stored via IPFS Pinata nodes for decentralized, efficient storage and retrieval.
          </li>
          <li>
            <strong>State Management:</strong> React Native state management solutions for handling user data, authentication state, and real-time updates within the mobile application.
          </li>
          <li>
            <strong>Error Handling:</strong> Comprehensive error handling on both frontend and backend, with user-friendly error messages and proper logging for debugging.
          </li>
          <li>
            <strong>Security:</strong> Secure authentication mechanisms, encrypted data transmission, and proper input validation to protect user data and prevent security vulnerabilities.
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Requirements;

